import { createApp, nextTick } from 'vue';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import eventBus from './eventBus';
import router from './router';
import store from './store/index';
import axios from './_services/axios';
import { handleResponseError } from './_services/responseErrorHandler';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@/styles/app.styl';

const app = createApp(App);

app.config.globalProperties.$http = axios;

app.config.globalProperties.$http.interceptors.response.use(
  response => response,
  function (error) {
    return handleResponseError(error, store, router);
  },
);

const token = localStorage.getItem('token');

if (token) {
  app.config.globalProperties.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`;

  store.dispatch('user/user', localStorage.getItem('username')).catch(() => {
    store.dispatch('auth/logout');
  });
}

app.config.globalProperties.$title = title => {
  document.title = `${title} - Application L'Outil`;
};

app.config.globalProperties.$bus = eventBus;

router.afterEach((to, from) => {
  if (to.path === from.path) {
    return;
  }
  nextTick(() => {
    document.title = to.meta.title || "Application L'Outil";
  });
});

app.use(router).use(store).use(vuetify).mount('#app');
